<template>
    <div id="app">
        <routerView />
        <cssStyle />
    </div>
</template>

<script>
import cssStyle from './views/Style.vue'

export default {
    name: 'app',
    components: {
        cssStyle,
    },
    computed: {},
}
</script>
